<template>
	<div class="gb-colors">
	</div>
</template>
<script>
import {COLOR_SELECT_TYPE} from '../data/Const';
export default {
	name: "GBClasses",
	props: [ "items", "max_width", "all_show", "type", "select_type" ],
	methods: {
		display: function() {
			while (this.$el.firstChild)
				this.$el.removeChild(this.$el.firstChild);
			let width = 0;
			for (let item of this.items) {
				let span = document.createElement('span');
				span.setAttribute('style', this.styleColorItem(item));
				span.setAttribute('class', 'color-item');
				span.innerHTML = this.nameColor(item);
				this.$el.appendChild(span);
				let span_width = span.offsetWidth + 3;	// add margin-right
				width += span_width;
				if (this.max_width < width) {
					if (this.all_show) {
						this.$el.insertBefore(document.createElement('br'), span);
						width = span_width;
					} else {
						span.innerHTML = ' &gt;&gt;';
						span.removeAttribute('class');
						span.removeAttribute('style');
						break;
					}
				}
			}
			if (this.items.length == 0) {
				let span = document.createElement('span');
				span.innerHTML = '&nbsp;';
				this.$el.appendChild(span);
			}
			return true;
		},
	},
	computed: {
		createColor: function() {
			return function(code) {
				return this.$store.getters.displayColor(code, this.type);
			};
		},
		styleColorItem: function() {
			return function(item) {
				if (this.isSingleSelect)
					return "background-color: " + this.createColor(item.code).asHex;
				return "background-color: " + item.asHex;
			};
		},
		nameColor: function() {
			return function(item) {
				if (this.isSingleSelect)
					return this.createColor(item.code).name;
				return item.name;
			};
		},
		isSingleSelect: function() {
			return this.select_type === COLOR_SELECT_TYPE.SINGLE;
		},
	},
	mounted: function() {
		this.display();
	},
	watch: {
		items: {
			handler: function () {
				this.display();
			},
			deep: true,
		},
	},
	beforeDestroy: function() {
		while (this.$el.firstChild)
			this.$el.removeChild(this.$el.firstChild);
	},
};
</script>
<style>
	.gb-colors {
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	
	.gb-colors .color-item {
		padding: 3px 10px;
		color: white;
		border-radius: 20px;
	}

	.gb-colors > span {
		font-size: .75em;
		margin-right: 3px;
	}
</style>
